import { fun_PostAction } from "@/api/index";
export default {
  data() {
    return {
      // 默认关闭
      dialogVisible: false,
      // 加载
      loading: false,
      // 查询表单绑定值
      form: {
        modifyTypeId: null, // 变更类型
        modifyMark: null, // 变更内容
        modifyDate: null // 变更批准时间
      },
      // 查询表单基础数据
      formSearchList: [
        {
          type: "input",
          label: "变更经办人：",
          value: "modifyPerson"
        },
        {
          type: "input",
          label: "变更时间：",
          value: "modifyDate"
        },
        {
          type: "input",
          label: "变更原因：",
          value: "modifyMark"
        }
      ],
      // 表格基础数据
      tableColumns: [
        {
          label: "变更状态",
          prop: "noticeStateName",
        },
        {
          label: "核验状态",
          type: "slot",
          slotName: "state",
        },
        {
          label: "变更经办人",
          prop: "modifyPerson"
        },
        {
          label: "变更时间",
          prop: "modifyDate"
        },
        {
          label: "变更原因",
          prop: "modifyMark"
        }
      ],
      // 列表数据
      tableData: [],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      // 分页总条数
      total: 0,
    };
  },

  // 接收父组件传递的数据
  props: {
    // 公告编号
    announcementId: {
      type: String
    }
  },

  // 模板编译完成
  mounted() { },

  // 自定义方法
  methods: {
    /**
     * 获取列表一览数据
     * @author shuhua
     */
    fun_GetList() {
      // 打开加载
      this.loading = true;
      // 发起请求
      fun_PostAction("/noticeModifyInfo/list", {
        ...this.form,
        ...this.reqPageData,
        announcementId: this.announcementId
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 表格数据
          this.tableData = data.records;
          // 总条数
          this.total = data.total;
          // 关闭加载
          this.loading = false;
        } else {
          // 错误消息提示
          this.$message.error(msg);
          // 关闭加载
          this.loading = false;
        }
      });
    },

    /**
     * 查询事件
     * @author shuhua
     */
    fun_Search() {
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 重置
     * @author 滕威
     */
    fun_Reset() {
      // 清除查询表单
      this.$refs.list.$refs.formItem.map(e => {
        e.resetField();
      });
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },

    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },

    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    }
  }
};
